
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit/museum-details/chiang-mai",
      function () {
        return require("private-next-pages/visit/museum-details/chiang-mai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visit/museum-details/chiang-mai"])
      });
    }
  